export default "__VITE_ASSET__Cpjg0pS3__"